import type { TipsContent } from "@/app/components/Tips";

/**
 * This section collects gender, marital status and date of birth. The copy here
 * used to describe the written "personal profile" paragraph — advice that
 * belongs to the Professional Summary section and said nothing about the fields
 * actually on the form.
 */
const personalProfile: TipsContent = {
	summary: "Personal details that some employers ask to see on a CV. Everything here is optional.",
	tips: [
		"Leave out anything you would rather not share. Every field can stay blank.",
		"Only fill in the details the employer or the application form actually asks for.",
		"These details appear on some resume templates. Use Preview to check how yours looks.",
		"Employers in many countries do not ask for them at all, so leaving them out will not count against you.",
	],
};

export default personalProfile;
